export default function isSignage(playlist, playlistTimer) {
  return (playlist && playlistTimer && playlist[playlistTimer.index]?.type === 'storage');
}
